module.exports = __webpack_public_path__ + "img/flow-map.fc0f045d.png";